import { clientApi } from 'shared/api/clientApi'

import type { KyrgyzstanCollectionsResponse } from './model'

export const KyrgyzstanCollectionsApi = {
  getCollections() {
    return clientApi.get<KyrgyzstanCollectionsResponse>(
      '/kyrgyzstan/search-presets/collections',
    )
  },
}
